define('modules/base/views/subscription.button.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/submenu.view",
    //'modules/settings/models/plans.model',
    "text!modules/base/templates/subscription.button.template.html"
], function(
    Prospector,
    $,_,Backbone,Marionette,
    SubMenuView,
    //PlansModel,
    Template
){
    var SubscriptionBtnView = SubMenuView.extend({
        className: 'SubscriptionBtn',
        template: _.template(Template),
        events:{
            'click .upgradePlan' : 'procPurchaseCategory'
        },
        initialize: function(options){
            this.model = options.model;
            SubMenuView.prototype.initialize.call(this, options);
        },
        /*procPurchaseCategory:function(){
            this.plans = new PlansModel();
            this.plans.once('sync', this.procPlansModel, this);
            this.plans.fetch();
        },
        procPlansModel:function(){
            Prospector.trigger('addCreditCard', {parent: this, plan: 8, categoryId: 0});
        }*/
    });
    return SubscriptionBtnView;
});

